import styled from 'styled-components'
import { palette } from 'theme/palette'

export const GreetingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;
  margin-right: 8px;
`

export const CloseIconContainer = styled.button.attrs(() => ({
  tabIndex: 0
}))<{ isMobileDevice: boolean }>`
  position: absolute;
  top: -22px;
  right: -22px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
  width: 44px;
  z-index: 1;
  cursor: pointer;
  background-color: ${palette.transparent};
  border: none;
  
  &:focus-visible {
    outline: 2px solid ${palette.mainBlue};
  }
`

export const CloseIcon = styled.img.attrs(() => ({
  alt: 'close greeting'
}))`
  border: 2px solid ${palette.white};
  background: ${palette.navyBlue};
  border-radius: 50%;
  padding: 1px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
`

export const GreetingTextContainer = styled.div`
  display: flex;
  background: ${palette.navyBlue};
  border-radius: 10px;
  animation: toggleOpacity .7s;
  cursor: pointer;
  padding: 8px;
  max-width: 224px;
  box-sizing: border-box;
  position: relative;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);

  &:after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    border-style: solid;
    border-width: 7px 0 7px 8px;
    border-color: transparent transparent transparent #1b4571;
    right: -8px;
    bottom: 50%;
    transform: translateY(50%);
  }
`

export const GreetingText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: ${palette.white};
  margin: 0;
`
